
import {Link} from 'react-router-dom';
import React, { useState, useEffect } from "react";
function Footer() {

  const [isOpen, setIsOpen] = useState(false);
  
    useEffect(() => {
     
      // Trigger popup 3 seconds after page load
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 3000);
  
      // Cleanup when component unmounts
      return () => clearTimeout(timer);
    }, []);
   const handleShareClick = () => {
    const whatsappUrl = `https://wa.me/+919528032385?text=I'm%20interested%20in%20your%20Shvetdhara%20products`;
    window.location.href = whatsappUrl;
  };
    return (
        <>
        <footer
          className="footer-wrapper footer-layout1"
          data-bg-src="assets/img/bg/footer_bg_1.jpg"
        >
          <div className="widget-area">
            <div className="container">
              <div className="row justify-content-between">
                <div className="col-md-6 col-xl-4">
                  <div className="widget footer-widget">
                    <div className="ot-widget-about">
                       <div className="header-logo" style={{margin:'-30px 0px 30px 0px'}}>
                                        <Link to="/">
                                              <img src="assets/img/Shvetdhara-Logo.webp" alt="Seedo" /></Link>
                                               <Link to="/">
                                            <h3>Shvetdhara</h3>
                                            <span>Har Din Ki Shuruaat, Shvetdhara ke Saath.</span>
                                            </Link>
                                          
                                          </div>
                      <p style={{color:'#000'}}>Quality dairy products made with care, delivered with trust. Every product crafted to bring health and happiness to your home.

</p>
                    <p style={{color:'#000'}}>Since 2002, our dairy brand has worked closely with local Indian farmers to bring the freshest, purest milk and dairy products directly to your home.</p>
                    
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-xl-auto">
                  <div className="widget widget_nav_menu footer-widget">
                    <h3 className="widget_title">Important Links</h3>
                    <div className="menu-all-pages-container">
                      <ul className="menu">
                      <li className="">
              <Link to="/">Home</Link>
              
              </li>
              <li>
              <Link to="/about">About us</Link>
              </li>
              
              <li>
              <Link to="/products">Products</Link>
              </li>
              
              <li>
              <Link to="/contact">Contact us</Link>
              </li>
              <li>
                        <Link to="/terms-and-conditions">Terms &amp; Condition</Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy">Privacy &amp; Policy</Link>
                      </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-xl-auto">
                  <div className="widget footer-widget">
                    <h3 className="widget_title">Contact Us</h3>
                    <div className="ot-widget-contact">
                      <div className="info-box">
                        <div className="info-box_icon">
                          <i className="fas fa-location-dot" />
                        </div>
                        <p className="info-box_text">
                       123 Dairy Excellence Park
Dehradun
                        </p>
                      </div>
                      <div className="info-box">
                        <div className="info-box_icon">
                          <i className="fas fa-phone" />
                        </div>
                        <p className="info-box_text">
                          <a href="tel:+91-98765 43210" className="info-box_link">
                            +91-98765 43210
                          </a>
                        </p>
                      </div>
                      <div className="info-box">
                        <div className="info-box_icon">
                          <i className="fas fa-envelope" />
                        </div>
                        <p className="info-box_text">
                          <a
                            href="mailto:business@shvetdhara.com"
                            className="info-box_link"
                          >
                           business@shvetdhara.com
                          </a>
                        </p>
                      </div>
                     
                    </div>
                  </div>
                </div>
          
              </div>
            </div>
          </div>
          <div
            className="copyright-wrap bg-style1"
            data-bg-src="assets/img/bg/copyright_bg_1.png"
          >
            <div className="container">
              <div className="row justify-content-between align-items-center">
                <div className="col-lg-6">
                  <p className="copyright-text">
                    <i className="fal fa-copyright" /> Copyright 2025 by{" "}
                    Shvetdhara. All rights reserved.
                  </p>
                </div>
              
              </div>
            </div>
          </div>
        </footer>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919"
              }}
            />
          </svg>
        </div>

        
   {/* Chat Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-4 right-4 bg-blue-600 text-white p-3 rounded-full shadow-lg whatsbtn"
        >
        <img src="assets/img/Whatsapp.svg" alt="Icon" />
        </button>
      )}

      {/* Chat Popup */}
      {isOpen && (
        <div className="fixed bottom-16 right-4 w-80 bg-white shadow-lg rounded-lg border border-gray-200 p-4 chtwidget">
         <button onClick={() => setIsOpen(false)} className="close">✖</button>
          <div className="h-40 overflow-y-auto border-t border-b py-2 mb-2 chatcontent">
          Welcome to DialERP !<br/>
          I’m your assistant—how can I help you today?
          <button onClick={handleShareClick}> <img src="assets/img/Whatsapp.svg" alt="Icon" /> Chat with us on Whatsapp</button>
          </div>
      
        </div>
      )}


       
      </>
      
    );
  }
  
  export default Footer;
  